export default {"src":"/_next/static/media/near_ai_logo.75299f1c.svg","height":12,"width":71,"blurWidth":0,"blurHeight":0};